import { useTranslation } from 'react-i18next'
import { IconButton, InputAdornment, TextField } from '@mui/material'

import { FormError } from '../../types/common.types'
import SearchIcon from '../../assets/icons/search-icon.svg'
import { textFieldWhiteBg } from '../../theme/custom-styles'

const ActionsBar = ({
  errors,
  paymentToSearch,
  handleClearSearchInput,
  handleSetPaymentToSearch
}: {
  errors: FormError
  paymentToSearch: string
  handleClearSearchInput: () => void
  handleSetPaymentToSearch: (paymentToSearchData: string, showError: boolean) => void
}) => {
  const { t } = useTranslation(['customer-details-management'])

  return (
    <div className="customer-details-actions-bar-container">
      <div className="customer-details-actions-bar-title">{t('actionsBar.title')}</div>
      <TextField
        variant="standard"
        sx={textFieldWhiteBg}
        label={t('searchField.placeholder')}
        value={paymentToSearch}
        error={!!errors.paymentToSearch}
        helperText={errors.paymentToSearch}
        className="customer-details-actions-bar-search-input"
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            handleSetPaymentToSearch(paymentToSearch, true)
          }
        }}
        onChange={(event) => {
          handleSetPaymentToSearch(event.target.value, true)
        }}
        onBlur={() => {
          if (paymentToSearch === '') handleClearSearchInput()
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                aria-label="toggle password visibility"
                sx={{ color: '#107569', right: '10px', bottom: '3px' }}
              >
                <img
                  src={SearchIcon}
                  alt="search-icon"
                />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
    </div>
  )
}

export default ActionsBar
